import { render, staticRenderFns } from "./TransitionStateEditor.vue?vue&type=template&id=485cb288"
import script from "./TransitionStateEditor.vue?vue&type=script&lang=js"
export * from "./TransitionStateEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports